export { MessageBody, type MessageBodyProps } from './MessageBody';
